import {
  put, takeLatest, delay, call,
} from 'redux-saga/effects';

import {
  FOTOGRAFIAS_UPLOAD_PHOTOS,
} from '../../actions/constants/sistemaSubidaFotografias/fotografias.constants';

import {
  endUploadingPhotosAction, discardCurrentPhotoAction, discardAllPhotosAction,
} from '../../actions/creators/sistemaSubidaFotografias/fotografias.actioncreator';

import {
  addNotificacion,
} from '../../actions/creators/sistemaNotificaciones/notificaciones.actioncreator';

import { authRequest } from '../../../helpers/request.helper';


function* subirFotografiasPendientes(action) {
  try {
    const { payload: { recursosPendientes } } = action;
    if (recursosPendientes.length > 0) {
      const formData = new FormData();
      formData.append('recursosPendientes', JSON.stringify(recursosPendientes));
      const params = {
        url: 'ficheros/subirFotosPendientes',
        method: 'POST',
        body: formData,
      };

      const response = yield call(authRequest, params);
      const { success } = response;

      if (success) {
        yield (put(discardCurrentPhotoAction()));
        yield (put(endUploadingPhotosAction()));
        yield (put(discardAllPhotosAction()));
        yield (put(addNotificacion('Se ha subido correctamente')));
      } else {
        yield (put(addNotificacion('Las fotos pendientes se subirán cuando tenga conexión')));
      }
    }
  } catch (error) {
    yield (put(addNotificacion('Las fotos pendientes se subirán cuando tenga conexión')));
  }
}


export function* uploadPhotosRequest() {
  yield takeLatest(FOTOGRAFIAS_UPLOAD_PHOTOS, subirFotografiasPendientes);
}
